var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-chip',_vm._b({staticClass:"v-status",class:[("v-status--" + (_vm.$props.type)), {'large-text': _vm.largeText}]},'v-chip',Object.assign({}, _vm.$props, _vm.$attrs),false),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }